import { FC } from 'react';
import Grid from '@mui/material/Grid';
import Hidden from '@mui/material/Hidden';
import { useAppSelector } from '../../store';
import { FacebookCode } from '../../social/components/facebook-code';
import { GoToLoginUrl } from '../../utils/login-logout-uri';
import { getQueryObj } from '../../utils/uri';
import LoginHeader from '../components/login-header/login-header';
import { LoginRightComponent } from '../components/login-right-component/login-right-component';
import { LoginForm } from './login-form';
import Maintenance from '../maintenance/maintenance';

const Login: FC = () => {
  const query = getQueryObj();
  const domainInfo = useAppSelector((state) => state.domainInfo);
  const panelInfo = useAppSelector((state) => state.panelInfo);
  // render
  if (domainInfo?.maintenance_window_enabled === true) {
    return <Maintenance />;
  }
  if (query.fromFbLogin && query.code) {
    return <FacebookCode code={query.code} />;
  }
  if (domainInfo?.web_app_login) {
    return (
      <>
        <LoginHeader logo={panelInfo?.app_theme.secondary_logo_image_url} links={panelInfo.app_settings.links} />
        <Grid container sx={{ flexGrow: 1 }}>
          <Grid item xs={12} md={6} sx={{ paddingTop: '88px' }}>
            <LoginForm isWidget={false} />
          </Grid>
          <Hidden mdDown>
            <Grid item xs={12} md={6}>
              <LoginRightComponent backgroundImage={panelInfo?.app_theme.login_image_url} />
            </Grid>
          </Hidden>
        </Grid>
      </>
    );
  }
  return <GoToLoginUrl />;
};

export default Login;
